// SP-15066 — each interface only offers the accounts of its brand. `brand_urls` stays null
// until client.talentwork.fr opens: nothing changes before.

import { BRAND_STUDENT_POP, BRAND_TALENT_WORK, hostBrand } from '@/plugins/brand';

const isTempAgency = (node) => Boolean(node.is_temp_agency_mode || node.isTempAgencyMode);

// Keeps the accounts of the brand, and the other-brand accounts holding some.
const prune = (children, talentWork) => (children || [])
  .map((child) => {
    const kept = prune(child.children, talentWork);

    return isTempAgency(child) === talentWork || kept.length ? { ...child, children: kept } : null;
  })
  .filter(Boolean);

const hasBrand = (company, talentWork) => isTempAgency(company) === talentWork
  || prune(company.children, talentWork).length > 0;

export default (account) => {
  account.mainCompanyId = account.companies.length ? account.companies[0].id : null;
  if (!account.brandUrls) {
    return account;
  }

  const talentWork = hostBrand() === BRAND_TALENT_WORK;
  const companies = account.companies.filter((company) => hasBrand(company, talentWork));
  if (account.companies.length && !companies.length) {
    account.brandRedirectUrl = account.brandUrls[talentWork ? BRAND_STUDENT_POP : BRAND_TALENT_WORK];
  }
  account.talentWorkBanner = !talentWork && account.companies.some((company) => hasBrand(company, true));
  account.companies = companies.map((company) => ({ ...company, children: prune(company.children, talentWork) }));
  if (account.company) {
    account.company.children = prune(account.company.children, talentWork);
  }

  return account;
};
